module.exports = __webpack_public_path__ + "static/img/building-overlay__relation.39c1e48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/building-overlay__relation.png
// module id = 445
// module chunks = 1